import React from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import Footer from './footer/footer';
import Navbar from './navbar/navbar';
import Disclaimer from 'src/components/disclaimer/disclaimer';
import * as routes from 'src/constants/routes';
import css from './layout.module.scss';
import ScrollArrow from '../scroll-arrow/scroll-arrow';
import CookiesNotice from '../cookies-notice/cookies-notice';
import SubscribeModal from '../subscribe/subscribe-modal';
import UnsubscribeModal from '../subscribe/unsubscribe';

Layout.propTypes = {
  children: PropTypes.node
};

const unsubcribeSearch = 'unsubscribe';

export default function Layout({ children }) {
  const location = useLocation();
  const [search, setSearch] = useSearchParams();
  const showDisclaimer =
    location.pathname.startsWith(routes.CAREER_INFO.path) ||
    location.pathname.startsWith(routes.EDUCATION.path) ||
    location.pathname.startsWith(routes.PSYCHOLOGICAL_HELP.path) ||
    location.pathname.startsWith(routes.MEDICAL_SERVICES.path) ||
    location.pathname.startsWith(routes.LEGAL_HELP.path) ||
    location.pathname.startsWith(routes.USEFUL_INFO.path) ||
    location.pathname.startsWith(routes.BUSINESS_MAP.path) ||
    location.pathname.startsWith(routes.EVENTS.path);

  const email = search.get('unsubscribe');

  return (
    <div className={css.layout}>
      <div className={css.content}>
        <Navbar />
        {children}
        <Footer />
        {showDisclaimer && <Disclaimer />}
        <ScrollArrow />
        <CookiesNotice />
        <SubscribeModal />
        {location?.search.includes(unsubcribeSearch) && email !== null && (
          <UnsubscribeModal
            email={email}
            onClose={() => {
              const nextSearchParams = new URLSearchParams(search);

              search.delete('unsubscribe');
              setSearch(nextSearchParams);
            }}
          />
        )}
      </div>
    </div>
  );
}
